import React, { useState } from 'react';
import { Alert, Button, Col, Modal, Row } from 'antd';
// import { useAuth, useSendCreationSociogram } from '@BUP/hooks';
import styles from './activation-sociogram-modal.module.css';

const ActivationSociogramModal = ({
  modalTitle,
  modalButton1,
  modalButton2,
  modalBody,
  errorMessageModal,
  messageSuccess,
  handleClickSociogram,
  dataResponse,
  errorResponse,
  errorResponseMessage,
  buttonModalText,
  closable,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  // Funciones para controlar modal
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      {!dataResponse ? (
        <>
          <Button
            type="primary"
            className={styles.button__closing_request}
            onClick={showModal}
            block
          >
            {buttonModalText}
          </Button>

          <Modal
            title={modalTitle}
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
              <Row align="space-evenly">
                <Col span={10}>
                  <Button
                    className={styles.cancel_button}
                    type="primary"
                    onClick={handleCancel}
                  >
                    {modalButton1}
                  </Button>
                </Col>
                <Col span={10}>
                  <Button
                    className={styles.conditions__modal_button2}
                    type="primary"
                    onClick={handleClickSociogram}
                  >
                    {modalButton2}
                  </Button>
                </Col>
              </Row>,
            ]}
          >
            <Row align="center">
              <Col>
                <p>{modalBody}</p>
              </Col>
            </Row>
          </Modal>
        </>
      ) : (
        <Alert
          className={styles.alert_success}
          message={messageSuccess}
          type="success"
          showIcon
          closable={closable}
        />
      )}
      {errorResponse ? (
        <Alert
          className={styles.alert_success}
          message={[
            <div>{errorMessageModal}</div>,
            <small>{errorResponseMessage}</small>,
          ]}
          type="error"
          showIcon
        />
      ) : null}
    </div>
  );
};

export default ActivationSociogramModal;
